import { Link } from 'react-router-dom';
import { siteConfig, categories } from '@/mocks/home';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="font-heading text-2xl font-bold tracking-wide text-background-50">
              {siteConfig.name}
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              {siteConfig.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              风月雅集
            </h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="whitespace-nowrap text-sm text-foreground-300 hover:text-accent-400 transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="whitespace-nowrap text-sm text-foreground-300 hover:text-accent-400 transition-colors">首页</Link>
              <Link to="/about" className="whitespace-nowrap text-sm text-foreground-300 hover:text-accent-400 transition-colors">关于我们</Link>
              <Link to="/category/fengya-shenghuo" className="whitespace-nowrap text-sm text-foreground-300 hover:text-accent-400 transition-colors">风雅生活</Link>
              <Link to="/category/yuexia-fengliu" className="whitespace-nowrap text-sm text-foreground-300 hover:text-accent-400 transition-colors">月下风流</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              联系我们
            </h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-300">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                hello@aifengyue.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" />
                北京市东城区南锣鼓巷风月胡同8号
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-400" />
                010-8888-6666
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 text-foreground-300 hover:text-accent-400 hover:bg-foreground-700/50 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-sm" />
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 text-foreground-300 hover:text-accent-400 hover:bg-foreground-700/50 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-sm" />
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-700/30 text-foreground-300 hover:text-accent-400 hover:bg-foreground-700/50 transition-colors" aria-label="小红书">
              <i className="ri-reddit-line text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}